<template>
  
  <div class="main-pattern-login" v-touch:start="touchstart" v-touch:moving="touchmove" v-touch:end="touchend">
    <svg id="pattern-login" ref="svg" viewBox="0 0 30 30" draggable="false" ondragstart="return false;" >
      <path draggable="false" ondragstart="return false;" ref="indicator" id="indicator" :d="pathToSvg()" stroke-linecap="round" stroke-linejoin="round"></path>
      <circle draggable="false" ondragstart="return false;" v-for="(coord, i) in matrix" :key="i" ref="circle" :cx="coord[0]" :cy="coord[1]" r="3" :dataKey="i"></circle>
    </svg>
</div>
</template>
<script>
  export default {
  data() {
      return {
    matrix: [
      [5,5], // Cercle 1 ...
      [15,5],
      [25,5],
      [5,15],
      [15,15],
      [25,15],
      [5,25],
      [15,25],
      [25,25] // Cercle 9 
    ],
    path: [],
    trackMouseMove: false,
    screenX: 0,
    screenY: 0,
  }},
methods: {
    // Traduit la forme où le chemin ( PATH ) en ligne SVG qui apparaitras sur l'écran
    // L : line to - M : move to (fonctions SVG) 
    pathToSvg() {
      let svgB = null
    if (!this.path.length) return "";
    if (this.screenX && this.screenY && this.trackMouseMove)
      svgB = this.$refs.svg.getBoundingClientRect();
    return (
      this.path.map(
        function (n, i) {
          return (
            (i ? " L " : "M ") + this.matrix[n][0] + " " + this.matrix[n][1]
          );
        }.bind(this)
      ).join("") +
      (this.screenX && this.screenY && this.trackMouseMove
        ? " L " +
          ((this.screenX - svgB.left) * 30) / svgB.width +
          " " +
          ((this.screenY - svgB.top) * 30) / svgB.width
        : "")
    );
  },
  //Touch events
  touchstart(ev){
    this.trackMouseMove = true
    this.path = []
    // Pour eviter le scroll durant le dessin
    document.body.style.overflow = 'hidden'
  },
  touchend(ev){
    this.trackMouseMove = false
    document.body.style.overflow = 'auto'
    this.login();
  },
  touchmove(ev){
    if (!this.trackMouseMove) return false
    var target = null
    if (ev.type == 'mousemove'){
      target = document.elementFromPoint(ev.clientX, ev.clientY)
      this.screenX = ev.clientX
      this.screenY = ev.clientY
    } else {
      let myLocation = ev.changedTouches[0]
      target = document.elementFromPoint(myLocation.clientX, myLocation.clientY)
      this.screenX = myLocation.clientX
      this.screenY = myLocation.clientY
    }
    let keyAsString = target.getAttribute('dataKey')
    let key = undefined
    if (keyAsString) key = Number(keyAsString)
    else return false
    const lastKey = this.path[this.path.length]
    if (lastKey == 0 && key == 2)
      this.path.push(1)
    if (lastKey == 0 && key == 6)
      this.path.push(3)
    if (lastKey == 0 && key == 8)
      this.path.push(4)
    if (lastKey == 1 && key == 7)
      this.path.push(4)
    if (lastKey == 2 && key == 1)
      this.path.push(1)
    if (lastKey == 2 && key == 6)
      this.path.push(4)
    if (lastKey == 2 && key == 8)
      this.path.push(5)
    if (lastKey == 3 && key == 5)
      this.path.push(4)
    if (lastKey == 5 && key == 3)
      this.path.push(4)
    if (lastKey == 6 && key == 0)
      this.path.push(3)
    if (lastKey == 6 && key == 8)
      this.path.push(7)
    if (lastKey == 6 && key == 4)
      this.path.push(4)
    if (lastKey == 7 && key == 1)
      this.path.push(4)
    if (lastKey == 8 && key == 0)
      this.path.push(4)
    if (lastKey == 8 && key == 2)
      this.path.push(5)
    if (lastKey == 8 && key == 6)
      this.path.push(7)
    if (!this.path.includes(key))
      this.path.push(key)
  },
  login(){
      console.log('Vous avez dessiné un pattern')
      // Pour l'authentification il faut integrer une API pour verifier le pattern courant avec celui de l'utilisateur.
    },
  }
}
  



  
</script>

<style  scoped>
.overflow-y-auto{ overflow-y: auto }
.fixed{ position: center }
.top-0{ top: 0}
.bottom-0{ bottom: 0}
.left-0{ left: 0}
.right-0{ right: 0}

main{
box-sizing: border-box;
text-align: center;
user-select: none;
}
svg#pattern-login{
cursor: pointer;
width: 300px;
height: 350px;
max-width: 80vmin;
max-height: 80vmin;
fill: transparent;
stroke: #5A6268;
stroke-width: 1px;
display: inline-block;
}

svg#pattern-login path#indicator{
stroke: rgb(10, 64, 172);
}

@keyframes loading{
to{ transform: translateX(500%)}
}
</style>